import { Action } from 'redux';

import { AddGroupsToGroupSet, DeleteGroupSets, EditGroupSet, GroupSetRemoveGroups } from '~src/bootstrap/redux/actions/AppActionTypes';

import { IGroupSetGroupInfo, IGroupSetInfo } from '../models/IGroupSetInfo';

export interface GroupSetsDeleteAction extends Action {
    groupSets: IGroupSetInfo[];
}

export function deleteGroupSets(groupSets: IGroupSetInfo[]): GroupSetsDeleteAction {
  return {
    type: DeleteGroupSets,
    groupSets
  };
}

export interface GroupSetAddGroupsAction extends Action {
  groupSet: IGroupSetInfo;
}

export function addGroupsToGroupSet(groupSet: IGroupSetInfo): GroupSetAddGroupsAction {
  return {
    type: AddGroupsToGroupSet,
    groupSet
  };
}

export interface GroupSetRemoveGroupsAction extends Action {
  groups: IGroupSetGroupInfo[];
}

export function removeGroupsFromGroupSet(groups: IGroupSetGroupInfo[]): GroupSetRemoveGroupsAction {
  return {
    type: GroupSetRemoveGroups,
    groups
  };
}

export interface GroupSetEditAction extends Action {
  groupSet: IGroupSetInfo;
}

export function editGroupSet(groupSet: IGroupSetInfo): GroupSetEditAction {
  return {
    type: EditGroupSet,
    groupSet
  };
}